/* Publish by EComposer at 2024-07-24 22:10:05*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-btd7x6fb7xu"]=  window.__ectimmers["ecom-btd7x6fb7xu"] || {};
let e=this.$el.querySelector(".ecom-shopify__article__excerpt-view-more-btn"),i=this.settings.excerpt_type,t=this.$el.querySelector(".ecom-shopify__article__excerpt--full"),n=this.$el.querySelector(".ecom-shopify__article__excerpt--paragraph");e&&e.addEventListener("click",function(){i==="text"&&t?(t.style.display="inherit",n.style.display="none"):n.style.maxHeight=null,this.style.display="none"})

                    });
                    
                        document.querySelectorAll('.ecom-btd7x6fb7xu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-btd7x6fb7xu', settings: {"excerpt_type":"text"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ypo79wer4wh"]=  window.__ectimmers["ecom-ypo79wer4wh"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-ypo79wer4wh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ypo79wer4wh', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-hmnkfkm1g9r"]=  window.__ectimmers["ecom-hmnkfkm1g9r"] || {};
const e=this.$el;if(!e)return;const i=e.querySelector("form");let t=this.settings.link_redirect;if(this.isLive){(function(){if(!t)return!1;let c=t.href;if(c=="")return!1;let u=t.target;window.location.href.includes("customer_posted=true")&&(u==="_blank"?window.open(c):window.location.href=c)})();const s=/^(\?|&)contact%5Btags%5D=[^&]+&form_type=customer(&|$)/;this.settings.scroll_in_view&&(window.location.pathname.includes("challenge")?setTimeout(function(){var c=document.querySelector(".shopify-challenge__container");c.scrollIntoView()},100):setTimeout(function(){(s.test(location.search)||window.location.href.includes("customer_posted=true"))&&e.scrollIntoView()},300)),s.test(location.search)&&i&&i.querySelector(".ecom-shopify__newsletter-form-message.ecom-dn")&&i.querySelector(".ecom-shopify__newsletter-form-message.ecom-dn").classList.remove("ecom-dn"),i&&i.dataset.ecTrackingId&&i.addEventListener("submit",function(){window.Shopify&&window.Shopify.analytics&&Shopify.analytics.publish("ec_custom_events",{button_id:i.id,tracking_id:i.dataset.ecTrackingId})},{once:!0});let o=e.querySelector(".ecom-shopify__newsletter__verify-checkbox"),a=e.querySelector(".ecom-shopify__newsletter__verify-error"),r=e.querySelector(".ecome-shopify__newsletter__button");o&&(r.addEventListener("click",function(c){o.checked==!1?(c.preventDefault(),a.classList.remove("ecom-dn")):a.classList.add("ecom-dn")}),o.addEventListener("change",function(c){o.checked&&a.classList.add("ecom-dn")}))}

                    });
                    
                        document.querySelectorAll('.ecom-hmnkfkm1g9r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hmnkfkm1g9r', settings: {"scroll_in_view":true},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-05aqdxmx7o5r"]=  window.__ectimmers["ecom-05aqdxmx7o5r"] || {};
var e=this.$el;if(e&&this.isLive){var o=e.querySelectorAll(".element-social-link:not(.element-social-link__custom)");o.length&&o.forEach(function(s){var n=s.getAttribute("href")||"#",r=n.replace("{current-link}",location.href);s.setAttribute("href",r)})}

                    });
                    
                        document.querySelectorAll('.ecom-05aqdxmx7o5r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-05aqdxmx7o5r', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}